export default __webpack_public_path__ + "static/media/iconeArvore.7ba02e17.png";